var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes,on:{"click":function($event){return _vm.$emit('toggle-tab', _vm.tab)}}},[_c('svg-vue',{staticClass:"inline-block h-6 mr-2 stroke-current text-primary",staticStyle:{"fill":"none"},attrs:{"icon":_vm.icon}}),_vm._v(" "+_vm._s(_vm.label)+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }